module.exports = __webpack_public_path__ + "static/media/basic_plan.0ad411b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/basic_plan.svg
// module id = 156
// module chunks = 0